module.exports = __webpack_public_path__ + "img/34.edca94f8.svg";